import type { DevicePresetCreate } from "@/types";

export type DevicePresetFormError = "required" | "displayInches";

export type DevicePresetBodyResult =
  | { ok: true; body: DevicePresetCreate }
  | { ok: false; error: DevicePresetFormError };

/** Validates the preset form and builds the trimmed create/update body (blank model omitted). */
export function buildDevicePresetBody(
  form: DevicePresetCreate,
): DevicePresetBodyResult {
  if (
    !form.brand.trim() ||
    !form.android_version.trim() ||
    !form.display_resolution.trim()
  ) {
    return { ok: false, error: "required" };
  }
  if (!Number.isFinite(form.display_inches) || form.display_inches <= 0) {
    return { ok: false, error: "displayInches" };
  }
  return {
    ok: true,
    body: {
      brand: form.brand.trim(),
      model: (form.model ?? "").trim() || undefined,
      android_version: form.android_version.trim(),
      display_resolution: form.display_resolution.trim(),
      display_inches: form.display_inches,
    },
  };
}
